<template lang="pug">
.nav-items
  li.nav-item.nav-item
    div(v-for="item in classRoom" :key="item.name")
      router-link.nav-link(v-if="item.authorityTag" :to="{ path: item.path }") {{ $t(item.name)}}
  li.nav-item.dropdown(v-if="profile_base.is_enabled_vip_product && getCanOrderClass")
    a.nav-link.dropdown-toggle(
      href='javascript:;'
      @click="toggleDropdown('startClass')"
    ) {{ $t('bookClass')}}
    .dropdown-menu(:class="[state === 'startClass' ?' d-block' :'d-none']")
      .dropdown-sort(:class="[state?'mt-1' :'mt-5']") {{ $t('book')}}
      div(v-for="item in bookLists" :key="item.name")
        router-link.dropdown-item(v-if="item.authorityTag" :to="{ path: item.path }") {{ $t(item.name) }}
      div(v-for="item in setRecordLists" :key="item.name")
        .dropdown-sort {{ $t('setRecord')}}
        router-link.dropdown-item(v-if="item.authorityTag" :to="{ path: item.path }") {{ $t(item.name) }}
  li.nav-item.dropdown
    a.nav-link.dropdown-toggle(
      href='javascript:;'
      @click="toggleDropdown('classRecord');isSubMenuOpenForP21=false;isSubMenuOpenForR21=false;"
    ) {{ $t('classRecord')}}
    .dropdown-menu(:class="[state === 'classRecord' ?' d-block' :'d-none']")
      div(v-for="item in classRecordLists" :key="item.name")
        router-link.dropdown-item(v-if="item.authorityTag && item.name !== 'learnRecords'" :to="{ path: item.path }") {{ $t(item.name) }}
        a.dropdown-item(v-if="item.authorityTag && item.name === 'learnRecords'" :href="`${newJrUrl}${item.path}`") {{ $t(item.name) }}
      li.dropdown-submenu
        a.dropdown-item.dropdown-toggle(@click="toggleSubMenuForP21") P21音檔
        ul.dropdown-menu(:class="{ show: isSubMenuOpenForP21 }" @click.stop)
          li
            a.dropdown-item(href='https://cws.cavesbooks.com.tw/bookseries.aspx?id=P21B1LIO' target='_blank') B1
          li
            a.dropdown-item(href='https://cws.cavesbooks.com.tw/bookseries.aspx?id=P21B2LIO' target='_blank') B2
          li
            a.dropdown-item(href='https://cws.cavesbooks.com.tw/bookseries.aspx?id=P21B3LIO' target='_blank') B3
          li
            a.dropdown-item(href='https://cws.cavesbooks.com.tw/bookseries.aspx?id=P21B4LIO' target='_blank') B4
      li.dropdown-submenu
        a.dropdown-item.dropdown-toggle(@click="toggleSubMenuForR21") R21音檔
        ul.dropdown-menu(:class="{ show: isSubMenuOpenForR21 }" @click.stop)
          li
            a.dropdown-item(href="https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B1LIO" target="_blank") B1
          li
            a.dropdown-item(href="https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B2LIO" target="_blank") B2
          li
            a.dropdown-item(href="https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B3LIO" target="_blank") B3
          li
            a.dropdown-item(href="https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B4LIO" target="_blank") B4
          li
            a.dropdown-item(href="https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B5LIO" target="_blank") B5
          li
            a.dropdown-item(href="https://cws.cavesbooks.com.tw/bookseries.aspx?id=R21B6LIO" target="_blank") B6
      div
        a.dropdown-item(href="https://www.cavesbooks.com.tw/EC/book_fair.aspx#3191" target="_blank") 魔法故事屋
  li.nav-item
    div(v-for="item in mgm" :key="item.name")
      router-link.nav-link(v-if="item.authorityTag" :to="{ path: item.path }") {{ $t(item.name)}}
  li.nav-item
    div(v-for="item in guide" :key="item.name")
      router-link.nav-link(v-if="item.authorityTag" :to="{ path: item.path }") {{ $t(item.name)}}
</template>

<script>
import i18n from '@/components/nav/lang';
import navList from '@/components/nav/navList';
import lioshutanApi from '@/api';
import dropdowControlMixin from '@/components/nav/headerNav/mixin/dropdowControlMixin.vue';
export default {
  name: 'VipHeaderNav',

  components: {},

  mixins: [dropdowControlMixin],

  i18n,

  data() {
    return {
      newJrUrl: new URL(window.location).origin,

      classRoom: navList.vip.classRoom,

      bookLists: navList.vip.bookLists,

      setRecordLists: navList.vip.setRecordLists,

      classRecordLists: navList.vip.classRecordLists,

      mgm: navList.vip.mgm,

      guide: navList.vip.guide,

      wushareList: navList.vip.wushareList,

      coupon: navList.vip.coupon,

      profile_base: {
        english_name: 'English Name',
        photo: '',
      },
      isSubMenuOpenForP21: false,
      isSubMenuOpenForR21: false,
    };
  },
  computed: {
    getCanOrderClass() {
      return this.$store.getters['vipAccount/getCanOrderClass'];
    },
  },
  async mounted() {
    this.getStudentPorfile();
    await this.getVipPointSuggest();
  },
  methods: {
    toggleSubMenuForP21() {
      this.isSubMenuOpenForR21 = false;
      this.isSubMenuOpenForP21 = !this.isSubMenuOpenForP21;
    },
    toggleSubMenuForR21() {
      this.isSubMenuOpenForP21 = false;
      this.isSubMenuOpenForR21 = !this.isSubMenuOpenForR21;
    },
    getStudentPorfile() {
      lioshutanApi.vip.getBaseProfile().then((result) => {
        this.profile_base = { ...result.data.profile_base, ...result.data.customized_classroom_rule };
      });
    },
    async getVipPointSuggest() {
      if (localStorage.getItem('wuwow_token')) {
        const res = await lioshutanApi.vip.getContractElapsedTime();
        // const res_vip = await lioshutanApi.vip.getVipPointSuggest();
        // console.log(`res_vip:${JSON.stringify(res_vip)}`);
        this.$store.dispatch('vipAccount/setPlatform', res.data.platform);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// 暑期
@import "@/styles/layout/layout.scss";

.nav-bar .nav .nav-items .nav-item .nav-link {
  padding: 0 8px;

  @include media-breakpoint-up(xl) {
    padding: 0 25px;
  }
}

.dropdown-submenu {
  position: relative;
}

.dropdown-submenu a::after {
  transform: rotate(-90deg);
  position: absolute;
  right: 6px;
  top: 1.5em;
}

.dropdown-submenu .dropdown-menu {
  top: 0;
  left: 100%;
  margin-left: 12px;
  margin-right: .1rem;
}

// .dropdown-submenu .dropdown-menu.show{
//   margin-left: 12px;
// }
</style>
